/**
 * set of functions to enforce a data structure
 */
import feedNaming from '../utils/feedNaming';
import fieldsToStructure from './fieldsToStructure';
import feedsToStructure from './feedsToStructure';

const preservedFields = [
  'body',
  'dateLastModified',
  'hasRead',
  'replyCount',
  'isTemporary',
  'lastActiveUser',
  'participants',
  'subject',
  'isDirect',
  'group',
];
const getId = thread => thread.threadId || thread.id;

export default {
  ...feedsToStructure(feedNaming.threads, getId),
  ...fieldsToStructure(preservedFields),
  id: getId,

  isGroupThread(thread) {
    return thread.participants && thread.participants.length > 2;
  },
};



// WEBPACK FOOTER //
// ./~/virgo/src/structures/threadStructure.js